<header id="header">
  <div class="d-flex w-100 gap-5 align-items-center justify-content-between">
    <h1>{{ featureTitleKey$ | async | translate }}</h1>
    <div class="d-flex ">

      <div class="preferences-container">
        <a routerLink="/notifications" [routerLinkActive]="['active']" [class.has-unread-notifications]="hasUnreadNotifications$ | async">
          <i-tabler name="bell" class="icon"></i-tabler>
        </a>
        <div class="divider"></div>
        <a routerLink="/account" [routerLinkActive]="['active']">
          <i-tabler name="user-cog" class="icon"></i-tabler>
        </a>
        <div class="divider d-lg-none"></div>
        @if (showSidebar) {
          <div class="d-lg-none">
            @if (collapsed) {
              <button type="button" class="btn btn-link btn-link-primary btn-lg px-2" (click)="toggle($event)">
                <div class="d-flex justify-content-center align-items-center">
                  <i-tabler name="menu-2" class="icon"></i-tabler>
                </div>
              </button>
            }
            @if (showSidebar) {
              <div class="sidebar-container" cdkTrapFocus>
                @if (!collapsed) {
                  <button type="button" class="btn btn-link btn-link-primary btn-lg px-2" (click)="toggle($event)">
                    <div class="d-flex justify-content-center align-items-center">
                      <i-tabler name="x" class="icon"></i-tabler>
                    </div>
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</header>
<div class="sidebar-position d-lg-none">
  <div class="sidebar" [collapse]="collapsed" [isAnimated]="true">
    <div class="container px-0 pt-3">
      <div class="sidebar-scrollable-view pr-2">
        <app-side-menu></app-side-menu>
      </div>
    </div>
  </div>
</div>

